module.exports = {
      id: "icon-premium-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-premium",
      toString: function () {
        return this.url;
      }
    }